/* Coverly — "ships Aug 27th – Aug 31st" on a product card.

   Same arithmetic as the compare table: custom.handling is a number of days,
   and the window runs from today + handling to that plus a spread. It is done
   in the browser on purpose — a date baked into Liquid would be cached and go
   stale, telling a shopper in November about a date in August. */
(function () {
  var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  function ordinal(d) {
    if (d > 3 && d < 21) return "th";
    if (d % 10 === 1) return "st";
    if (d % 10 === 2) return "nd";
    if (d % 10 === 3) return "rd";
    return "th";
  }

  function day(date) { return MONTHS[date.getMonth()] + " " + date.getDate() + ordinal(date.getDate()); }

  function window_(handlingDays, spreadDays) {
    var from = new Date();
    from.setHours(0, 0, 0, 0);
    from.setDate(from.getDate() + handlingDays);
    var to = new Date(from);
    to.setDate(to.getDate() + spreadDays);
    return day(from) + " – " + day(to);
  }

  function fill(el) {
    if (el.dataset.shipDone === "true") return;
    var cfg = el.closest("[data-ship-fallback]");
    var fallback = Number(cfg && cfg.dataset.shipFallback) || 18;
    var spread = Number(cfg && cfg.dataset.shipSpread) || 4;

    var own = Number(el.dataset.shipDays);
    var days = Number.isFinite(own) && own > 0 ? own : fallback;

    var when = el.querySelector("[data-ship-when]");
    if (!when) return;
    when.textContent = window_(days, spread);
    el.hidden = false;                 // hidden until filled, so no empty label flashes
    el.dataset.shipDone = "true";
  }

  function run() { document.querySelectorAll("[data-ship-days]").forEach(fill); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  // Dawn swaps the grid out on sort and pagination.
  document.addEventListener("shopify:section:load", run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
